export { StatsMosaicSection as StatBand } from "../expanded-section-pack"